var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[(_vm.loading)?_c('v-btn',{staticClass:"bottom-button",attrs:{"loading":"","flat":""}}):_c('v-btn',{staticClass:"bottom-button",attrs:{"disabled":!_vm.hasUnreadNotifications,"xs3":"","ma-2":""},on:{"click":_vm.onReadAll}},[_vm._v("\n    全て既読にする\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }